export default {"src":"/_next/static/media/binance.2e1c0bcb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};